global.sleep = (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
}

global.enableAjaxSpinner = () => {
	localStorage.removeItem('disable-spinner');
}

global.disableAjaxSpinner = () => {
	localStorage.setItem('disable-spinner', 'true');
}

const mergeDeep = (target, ...sources) => {
	if (!sources.length) return target;
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, {[key]: {}});
				mergeDeep(target[key], source[key]);
			} else {
				Object.assign(target, {[key]: source[key]});
			}
		}
	}

	return mergeDeep(target, ...sources);
}

// Export as global for backward compatibility and direct usage
global.mergeDeep = mergeDeep;
window.mergeDeep = mergeDeep;

global.queryStringToObject = (queryString) => {
	const pairs = queryString.substring(1).split('&');
	// → ["foo=bar", "baz=buzz"]

	var array = pairs.map((el) => {
		const parts = el.split('=');
		return parts;
	});
	// → [["foo", "bar"], ["baz", "buzz"]]

	return Object.fromEntries(array);
	// → { "foo": "bar", "baz": "buzz" }
}

global.isObject = (item) => {
	return (item && typeof item === 'object' && !Array.isArray(item));
}

global.arrayRange = (start, stop, step) =>
	Array.from(
		{length: (stop - start) / step + 1},
		(value, index) => start + index * step
	);

global.number_format = (number, decimals, decPoint, thousandsSep) => {
	number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
	const n = !isFinite(+number) ? 0 : +number
	const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
	const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
	const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
	let s = ''
	const toFixedFix = function (n, prec) {
		if (('' + n).indexOf('e') === -1) {
			return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
		} else {
			const arr = ('' + n).split('e')
			let sig = ''
			if (+arr[1] + prec > 0) {
				sig = '+'
			}
			return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
		}
	}
	// @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || ''
		s[1] += new Array(prec - s[1].length + 1).join('0')
	}
	return s.join(dec)
}

global.txtToAplKod = function (str) {
	let result = [];
	let strLen = str.length;
	let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊĚËèéêěëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüůÑŇñňŠšŸÿýŽžŘřČč';
	let accentsOut = ['A', 'A', 'A', 'A', 'A', 'A', 'a', 'a', 'a', 'a', 'a', 'a', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'o', 'o', 'o', 'o', 'o', 'o', 'E', 'E', 'E', 'E', 'E', 'e', 'e', 'e', 'e', 'e', 'e', 'C', 'c', 'D', 'I', 'I', 'I', 'I', 'i', 'i', 'i', 'i', 'U', 'U', 'U', 'U', 'u', 'u', 'u', 'u', 'u', 'N', 'N', 'n', 'n', 'S', 's', 'Y', 'y', 'y', 'Z', 'z', 'R', 'r', 'C', 'c'];
	for (let y = 0; y < strLen; y++) {
		if (accents.indexOf(str[y]) !== -1) {
			result[y] = accentsOut[accents.indexOf(str[y])];
		} else {
			result[y] = str[y];
		}
		result[y] = result[y].toLowerCase();
	}

	result = result.join('');
	result = result.replace(/[^0-9a-z]+/g, '-'); // nahrazeni vsech cizich znaku zasebou za jednu pomlcku
	result = result.replace(/[\-]+$/g, ''); // odstraneni poslednich pomlcek
	result = result.replace(/([a-z])([0-9])/ig, '$1-$2'); // mezi skupinou cisel a pismen udelame vzdy pomlcku z obou stran
	result = result.replace(/([0-9])([a-z])/ig, '$1-$2');

	return result;
}
